/* eslint-disable no-plusplus */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-translate';
import YoutubeModal from 'react-youtube-modal';
import { Button, Container, Dropdown, Form, Grid, Header, Icon, Image, Label, List, Modal, Segment, Table } from 'semantic-ui-react';
import envList, { getFirstPage } from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import API from '../../../services/Api';
import PDFService, { PageType } from '../../../services/PDFService';
import StandardService from '../../../services/StandardService';
import UserService from '../../../services/userService';
import ComponentTable from '../../shared/ComponentTable';
import ComponentTableIME from '../../shared/ComponentTableIME';
import HeaderComponent from '../../shared/HeaderComponent';
import TechnicalInfoIcon from '../../shared/TechnicalInfoIcon';
import JobList from '../projet/jobList';
import productInfos from '../projet/productInfos';
import './RtMaxSoluceComponent.css';
import { onBlurFactory, onChangeFactory, prepareState } from './utils';
import RtMaxService from '../../../services/rtMaxService';

const kitFit032 = 'https://www.knaufinsulation.fr/produits/ki-fit-032';
const kitFit035 = 'https://www.knaufinsulation.fr/produits/ki-fit-035';
const suspentes = 'https://www.knaufinsulation.fr/produits/suspentes-rt-max';
const adhesifRtMaxPdf = 'https://fr.knaufinsulation.accounts.intracto.com/produits/adhesif-rt-max';
const masticRtMaxPdf = 'https://fr.knaufinsulation.accounts.intracto.com/produits/mastic-rt';
let adhesifRtMaxPdfPath = '';
let masticRtMaxPdfPath = '';

class rtMaxSoluceComponent extends Component {
  static clickDownloadRtmaxPdf(urlToOpen) {
    const windowRef = window.open(urlToOpen, '_blank');
    windowRef.focus();
  }

  constructor(props) {
    super(props);
    this.state = {
      size: window.innerWidth,
    };
    // Initial State

    this.state.entreChevronsPriceRtmax = 0;
    this.state.sousChevronsPriceRtmax = 0;
    this.state.suspentesPriceRtmax = 0;
    this.state.membranePriceRtmax = 0;
    this.state.adhesifPriceRtmax = 0;
    this.state.masticrtMaxPrice = 0;

    if (props.location && props.location.state) {
      this.state = props.location.state;
    }

    const { isoValue } = this.state;

    this.state.suspentesRtmax = isoValue * 2.5;
    this.state.suspentesQuantityRtmax = (isoValue * 2.5) / 50;
    this.state.membraneRouleauxRtmax = Math.ceil(
      (isoValue * 1.3) / 75
    );
    this.state.adhesifRTMaxSolution = isoValue * 2.0;
    this.state.adhesifRTMaxQuantitySolution = (isoValue * 2.0) / 40;
    this.state.masticRTSolution = isoValue * 0.5;
    this.state.masticrtMaxQuantity = Math.ceil(
      (isoValue * 0.5) / 12
    );

    // Input changes

    this.changeEntreChevronsRtmax = this.changeEntreChevronsRtmax.bind(this);
    this.changeEntreChevronsPriceRtmax = this.changeEntreChevronsPriceRtmax.bind(
      this
    );
    this.changeSousChevronsRtmax = this.changeSousChevronsRtmax.bind(this);
    this.changeSousChevronsPriceRtmax = this.changeSousChevronsPriceRtmax.bind(
      this
    );
    this.changeSuspentesPriceRtmax = this.changeSuspentesPriceRtmax.bind(this);
    this.changeMembranePriceRtmax = this.changeMembranePriceRtmax.bind(this);
    this.changeAdhesifRtmaxPrice = this.changeAdhesifRtmaxPrice.bind(this);
    this.changeMasticrtMaxPrice = this.changeMasticrtMaxPrice.bind(this);

    // Calculation

    this.calculateEntreChevronsRtmax = this.calculateEntreChevronsRtmax.bind(
      this
    );
    this.calculateSousChevronsRtmax = this.calculateSousChevronsRtmax.bind(
      this
    );
    this.calculateSuspentesRtmax = this.calculateSuspentesRtmax.bind(this);
    this.calculateMembraneRtmax = this.calculateMembraneRtmax.bind(this);
    this.calculateAdhesifRtmax = this.calculateAdhesifRtmax.bind(this);
    this.calculateMasticrtMax = this.calculateMasticrtMax.bind(this);
    this.calculateRtMaxTotal = this.calculateRtMaxTotal.bind(this);
    this.changeMembraneRtmax = this.changeMembraneRtmax.bind(this);
    this.onChangeMembrane = this.onChangeMembrane.bind(this);
  }

  componentDidMount() {
    const { match: { params: { env } } } = this.props;
    const {
      epaisseurChevron,
      resValue,
      showMonocouche,
      isoValue,
    } = this.state;

    if (
      (
        (epaisseurChevron === 60
          && resValue === 10
          && showMonocouche === false)
        || (resValue === 10 && showMonocouche === true)
      )
      && envList.isCA(env)
    ) {
      this.setState({ modalOpen: true });
    } else if (
      resValue >= 8.5
      && showMonocouche === true
      && envList.isCA(env)
    ) {
      this.setState({ modalRtMaxMonocoucheOpen: true });
    } else if (envList.isCA(env) || envList.isCP(env)) {
      Promise.all([
        API.getPreselect(resValue, showMonocouche, epaisseurChevron),
        API.getProducts(),
      ]).then(([{ data: { preselect } }, res]) => {
        res.data.products.forEach((element) => {
          if (element.name === 'MASTIC RT') masticRtMaxPdfPath = element.link;
          if (element.name === 'ADHESIF RT MAX') adhesifRtMaxPdfPath = element.link;
        });

        const futurState = prepareState(res, preselect, isoValue, env);

        this.setState(
          {
            ...futurState,
          }, () => {
            if (envList.isCA(env) || envList.isCP(env)) {
              this.calculateRtMaxTotal();
              this.calculateResValue();
              envList.isCA(env) && this.calculateMembraneRtmax();
            }
          }
        );
      });

      window.scrollTo(0, 0);
      this.setState({ modalRtMaxMonocoucheOpen: false });
    }
    window.addEventListener('resize', this.resize.bind(this));
  }

  onChangeMembrane(_, inputData) {
    const { match: { params: { env } } } = this.props;
    const { value: selected } = inputData;
    const { isoValue } = this.state;

    const costs = RtMaxService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: selected,
      },
    ], isoValue, env);

    this.setState({
      selectedMembrane: selected,
      ...costs.membrane,
    }, () => {
      this.calculateRtMaxTotal();
      this.checkConformityRtmax();
    });
  }

  handleOpen = () => this.setState({ modalRtMaxMonocoucheOpen: true });

  handleClose = () => this.setState({ modalRtMaxMonocoucheOpen: false });

  handleOpenConfig = () => this.setState({ modalOpen: true });

  handleCloseConfig = () => this.setState({ modalOpen: false });

  resize = () => {
    this.setState({ size: window.innerWidth });
  }

  getJob = () => {
    const tmp = UserService.getTokenCleared();
    if (tmp) {
      return tmp.job;
    }

    return JobList.USER;
  };

  screenPage() {
    const { match: { params: { env } }, history } = this.props;
    PDFService.screenPage(PageType.RT_MAX).then(() => {
      history.push({
        pathname: `/${env}/rtplus`,
        state: this.state,
      });
    });
  }

  checkConformityRtmax() {
    const { match: { params: { env } } } = this.props;
    const isCP = envList.isCP(env);

    const {
      [isCP ? 'selectedInsulator' : 'entreChevronsItem']: entreChevronsItem,
      [isCP ? 'selectedInsulatorSecond' : 'sousChevronsItem']: sousChevronsItem,
      resValue,
      thermalValueRtmax,
      showMonocouche,
    } = this.state;

    const entreChevronsItemRtmax = entreChevronsItem || {};
    const sousChevronsItemRtmax = sousChevronsItem || {};

    const conformityRtmax = (
      showMonocouche
      || (
        entreChevronsItemRtmax
        && (entreChevronsItemRtmax.cpt === 'OUI' || entreChevronsItemRtmax.cpt === '1')
      )
    )
    && sousChevronsItemRtmax
    && (sousChevronsItemRtmax.cpt === 'OUI' || sousChevronsItemRtmax.cpt === '1');

    const isEnough = resValue <= thermalValueRtmax;
    this.setState({ conformityRtmax, isEnough });
  }

  changeSuspentesOptions() {
    const {
      arrayEntreChevronsRtmax,
      arraySousChevronsRtmax,
    } = this.state;
    const tab1 = arrayEntreChevronsRtmax || [];
    const tab2 = arraySousChevronsRtmax || [];
    let tabSuspentesRtmax = tab1.concat(tab2 || []);
    const idPositions = tabSuspentesRtmax.map(el => el.key);
    const newPayload = tabSuspentesRtmax.filter(
      (item, pos) => idPositions.indexOf(item.key) === pos
    );
    tabSuspentesRtmax = newPayload;
    if (tabSuspentesRtmax.length > 0) {
      const suspentesItemRtmax = tabSuspentesRtmax[0].value;
      const suspentesPriceRtmax = suspentesItemRtmax.price;
      this.setState(
        {
          suspentesPriceRtmax,
        },
        () => this.calculateSuspentesRtmax()
      );
    }
  }

  changeEntreChevronsRtmax(_, val) {
    const {
      suspentesOptions,
    } = this.state;
    const entreChevronsItemRtmax = val.value;
    const tabSuspentesEntre = [];
    API.getRelProduct(entreChevronsItemRtmax.id).then((res) => {
      const entreChevronsRel = res.data.relproductsproducts;
      entreChevronsRel.forEach((element) => {
        if (element.products_id_master === entreChevronsItemRtmax.id) {
          let found = false;
          let i = 0;
          while (i < suspentesOptions.length && !found) {
            if (
              suspentesOptions[i].key === element.products_id_remote
            ) {
              found = true;
              tabSuspentesEntre.push(suspentesOptions[i]);
            }
            i++;
          }
        }
      });

      const arrayEntreChevronsRtmax = tabSuspentesEntre.filter(
        x => x.value.workstype.indexOf('2') > -1
      );
      this.setState(
        {
          arrayEntreChevronsRtmax,
        },
        () => this.changeSuspentesOptions()
      );
    });
    const entreChevronsPriceRtmax = entreChevronsItemRtmax.price;
    this.setState(
      {
        entreChevronsPriceRtmax,
      },
      () => {
        this.calculateEntreChevronsRtmax();
        this.calculateResValue();
      }
    );
  }

  changeSousChevronsRtmax(evt, val) {
    const { entreChevronsOptions, entreChevronsItem } = this.state;

    this.setState({
      entreChevronsItem: {
        ...entreChevronsItem,
        price: val.value,
      },
    });
    for (let i = 0; i < entreChevronsOptions.length; i++) {
      if (entreChevronsOptions[i].text === entreChevronsItem.name) {
        entreChevronsOptions[i].value.price = val.value;
      }
    }
    this.setState({ entreChevronsOptions }, () => {
      this.calculateSousChevronsRtmax();
    });
  }

  changeSuspenteRtmax(evt, val) {
    const suspentesItemRtmax = val.value;
    const suspentesPriceRtmax = suspentesItemRtmax ? suspentesItemRtmax.price : 0;
    this.setState(
      {
        suspentesPriceRtmax,
      },
      () => this.calculateSuspentesRtmax()
    );
  }

  changeMembraneRtmax(_, inputData) {
    const membranesItemRtmax = inputData.value;
    const membranePriceRtmax = membranesItemRtmax.price;
    this.setState(
      {
        membranesItemRtmax,
        membranePriceRtmax,
      },
      () => { this.calculateMembraneRtmax(); }
    );
  }

  changeEntreChevronsPriceRtmax(_, val, noFormat) {
    const { entreChevronsOptions, entreChevronsItem } = this.state;

    entreChevronsItem.price = val.value;
    entreChevronsItem.noFormat = noFormat;

    for (let i = 0; i < entreChevronsOptions.length; i++) {
      if (entreChevronsOptions[i].key === entreChevronsItem.id) {
        entreChevronsOptions[i].value.price = val.value;
        entreChevronsOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({ entreChevronsOptions, entreChevronsItem }, () => {
      this.calculateEntreChevronsRtmax();
    });
  }

  changeSousChevronsPriceRtmax(_, val, noFormat) {
    const { sousChevronsOptions, sousChevronsItem } = this.state;

    sousChevronsItem.price = val.value;
    sousChevronsItem.noFormat = noFormat;

    for (let i = 0; i < sousChevronsOptions.length; i++) {
      if (sousChevronsOptions[i].key === sousChevronsItem.id) {
        sousChevronsOptions[i].value.price = val.value;
        sousChevronsOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({ sousChevronsOptions, sousChevronsItem }, () => {
      this.calculateSousChevronsRtmax();
    });
  }

  changeSuspentesPriceRtmax(_, val, noFormat) {
    const { suspentesOptions, suspentesItem } = this.state;

    suspentesItem.price = val.value;
    suspentesItem.noFormat = val.noFormat;

    for (let i = 0; i < suspentesOptions.length; i++) {
      if (suspentesOptions[i].text === suspentesItem.name) {
        suspentesOptions[i].value.price = val.value;
        suspentesOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({ suspentesOptions, suspentesItem }, () => {
      this.calculateSuspentesRtmax();
    });
  }

  // use in render
  changeMembranePriceRtmax(_, val, noFormat) {
    const { membraneOptions, membranePriceRtmax, membranesItemRtmax } = this.state;

    for (let i = 0; i < membraneOptions.length; i++) {
      if (membraneOptions[i].text === membranePriceRtmax.name) {
        membraneOptions[i].value.price = val.value;
        membraneOptions[i].value.noFormat = noFormat;
      }
    }

    membranesItemRtmax.price = val.value;
    membranesItemRtmax.noFormat = noFormat;

    this.setState({
      membraneOptions,
      membranePriceRtmax: val.value,
      membranesItemRtmax,
    }, () => {
      this.calculateMembraneRtmax();
    });
  }

  changeAdhesifRtmaxPrice(_, val, noFormat) {
    const { selectedAdhesif } = this.state;
    const adhesifPrice = val.value;
    selectedAdhesif.price = adhesifPrice;
    selectedAdhesif.noFormat = noFormat;

    this.setState(
      {
        selectedAdhesif,
      },
      () => { this.calculateAdhesifRtmax(); }
    );
  }

  changeMasticrtMaxPrice(_, val, noFormat) {
    const masticPrice = val.value;

    this.setState(
      {
        masticPrice,
        masticNoFormat: noFormat,
      },
      () => this.calculateMasticrtMax()
    );
  }

  calculateEntreChevronsRtmax() {
    const { entreChevronsItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.BETWEEN_CHEVRON,
        productData: entreChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifPerSurface: costs.betweenChevron.tarifPerSurface,
    }, () => {
      this.checkConformityRtmax();
      this.calculateRtMaxTotal();
    });
  }

  calculateSousChevronsRtmax() {
    const { sousChevronsItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.UNDER_CHEVRON,
        productData: sousChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifOnSurface: costs.underChevron.tarifOnSurface,
    }, () => {
      this.checkConformityRtmax();
      this.calculateRtMaxTotal();
    });
  }

  calculateSuspentesRtmax() {
    const { suspentesItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.SHROUD,
        productData: suspentesItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifDeSurface: costs.shroud.tarifDeSurface,
    }, () => {
      this.checkConformityRtmax();
      this.calculateRtMaxTotal();
    });
  }

  calculateMembraneRtmax() {
    const { membranesItemRtmax, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: membranesItemRtmax,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifMembraneRtmax: costs.membrane.tarifMembrane,
      membranePareVapeurRtmax: costs.membrane.membranePareVapeurRtmax,
    },
    () => this.calculateRtMaxTotal()
    );
  }

  calculateAdhesifRtmax() {
    const { isoValue, selectedAdhesif } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.ADHESIVE,
        productData: selectedAdhesif,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      adhesifCost: costs.adhesive.adhesifCost,
    }, () => {
      this.checkConformityRtmax();
      this.calculateRtMaxTotal();
    });
  }

  calculateMasticrtMax() {
    const { isoValue, masticPrice } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.MASTIC,
        productData: {
          quantity: Math.ceil((isoValue * 0.5) / 12),
          price: masticPrice,
        },
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifMasticRt: costs.mastic.tarifMasticRt,
    }, () => {
      this.checkConformityRtmax();
      this.calculateRtMaxTotal();
    });
  }

  calculateResValue() {
    const { match: { params: { env } } } = this.props;
    let thermalValue = 0;

    if (envList.isCP(env)) {
      const {
        selectedInsulator,
        selectedInsulatorSecond,
        selectedMembrane,
      } = this.state;

      thermalValue = Number(
        Number((selectedInsulator && selectedInsulator.resistance) || 0)
        + Number((selectedInsulatorSecond && selectedInsulatorSecond.resistance) || 0)
        + Number((selectedMembrane && selectedMembrane.resistance) || 0)
      ).toFixed(2);
    } else {
      const { entreChevronsItem, sousChevronsItem, showMonocouche } = this.state;
      const entreChevronsResRtmax = (
        entreChevronsItem || { resistance: 0 }
      ).resistance;

      const sousChevronsResRtmax = (
        sousChevronsItem || { resistance: 0 }
      ).resistance;

      thermalValue = (
        ((!showMonocouche && Number(entreChevronsResRtmax)) || 0) + Number(sousChevronsResRtmax)
      ).toFixed(1);
    }

    this.setState({
      thermalValueRtmax: thermalValue,
    }, () => {
      this.checkConformityRtmax();
    });
  }

  calculateRtMaxTotal() {
    const { match: { params: { env } } } = this.props;
    let total = 0;

    if (envList.isCP(env)) {
      const {
        costInsBet,
        costSec,
        costMem,
        adhesifCost,
        masticCost,
      } = this.state;

      total = Number(
        costInsBet + costSec + costMem + adhesifCost + masticCost
      ).toFixed(1);
    } else {
      const {
        adhesifCost,
        showMonocouche,
        tarifDeSurface,
        tarifMasticRt,
        tarifMembraneRtmax,
        tarifOnSurface,
        tarifPerSurface,
      } = this.state;
      const totalEntreChevronsRtmax = showMonocouche
        ? 0
        : Number(tarifPerSurface) || 0;
      const totalSousChevronsRtmax = Number(tarifOnSurface) || 0;
      const totalSuspentesRtmax = Number(tarifDeSurface) || 0;
      const totalMembraneRtmax = Number(tarifMembraneRtmax) || 0;
      const totalAdhesifRtmax = Number(adhesifCost) || 0;
      const totalMasticRtmax = Number(tarifMasticRt) || 0;
      total = Number(
        (showMonocouche ? 0 : totalEntreChevronsRtmax)
        + totalSousChevronsRtmax
        + totalSuspentesRtmax
        + totalMembraneRtmax
        + totalAdhesifRtmax
        + totalMasticRtmax
      ).toFixed(1);
    }

    this.setState({
      rtMaxTotal: total,
    });
  }

  advantagesrender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const advantages = productInfos[env].formula.rtMax.advantageKey[jobId].map(advantageId => (
      <li className="listItemBenefitRtmax">
        {t(advantageId)}
      </li>
    ));

    return (
      <ul className="listBenefitRtmax">
        {advantages}
      </ul>
    );
  }

  inconvenienceRender() {
    const { match: { params: { env } }, t } = this.props;

    const jobId = this.getJob();

    const inconvenience = productInfos[env]
      .formula.rtMax
      .inconvenienceKey[jobId]
      .map(inconvenienceId => (
        <li className="listItemBenefitRtmax">
          {t(inconvenienceId)}
        </li>
      ));

    return (
      <ul className="listBenefitRtmax">
        {inconvenience}
      </ul>
    );
  }

  componentRender() {
    const { match: { params: { env } }, t } = this.props;
    const { showMonocouche } = this.state;
    const { components } = productInfos[env].formula.rtMax;
    const toRender = [];
    let firstVisibleAdded = false;

    for (let i = 0; i < components.length; i++) {
      const component = components[i];

      toRender.push(
        <List.Item
          className={firstVisibleAdded ? 'listItemSoluce' : 'listrtMax'}
          style={
            !component.alwaysShow && showMonocouche
              ? { display: 'none' }
              : { display: 'block' }
          }
        >
          {t(component.key)}
        </List.Item>
      );

      if (component.alwaysShow || (!component.alwaysShow && !showMonocouche)) {
        firstVisibleAdded = true;
      }
    }

    return toRender;
  }

  renderComponentTable() {
    const { t, match: { params: { env } }, match } = this.props;
    const {
      adhesifBox,
      adhesifCost,
      entreChevronsItem,
      entreChevronsOptions,
      isoValue,
      masticNoFormat,
      masticPrice,
      masticrtMaxQuantity,
      masticRTSolution,
      membraneOptions,
      membranePareVapeurRtmax,
      membraneRouleauxRtmax,
      membranesItemRtmax,
      nbreRouleau,
      nbRouleau,
      pareVapeur,
      resValue,
      selectedAdhesif,
      showMonocouche,
      size,
      sousChevronsItem,
      sousChevronsOptions,
      surface,
      surfaceSousChevrons,
      suspentesItem,
      suspentesOptions,
      suspentesQuantityRtmax,
      suspentesRtmax,
      tarifDeSurface,
      tarifMasticRt,
      tarifMembraneRtmax,
      tarifOnSurface,
      tarifPerSurface,
    } = this.state;

    const token = sessionStorage.getItem('USER_TOKEN');

    switch (env) {
      case envList.CA.path:
        return (
          <Table basic="very" className="tableRtMaxSoluce">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell>{t('rtmax_table_title')}</Table.HeaderCell>
                <Table.HeaderCell />
                <Table.HeaderCell>
                  {t('rtmax_table_title_quantity')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t('rtmax_table_title_unité')}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t('rtmax_table_title_surface')}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
            showMonocouche || (
            <Table.Row>
              <Table.Cell>1. </Table.Cell>
              <Table.Cell className="cellTablertMax">
                {t('rtmax_table_iso_entre_chevrons')}
                <TechnicalInfoIcon
                  onClick={
                    () => rtMaxSoluceComponent.clickDownloadRtmaxPdf(
                      entreChevronsItem.link && entreChevronsItem.link.length > 0
                        ? entreChevronsItem.link
                        : kitFit032
                    )
                  }
                />
                <br />
                <Dropdown
                  search
                  selection
                  disabled
                  options={entreChevronsOptions}
                  value={entreChevronsItem}
                  onChange={(e, val) => this.changeEntreChevronsRtmax(e, val)
                  }
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(surface || 0).toFixed(2)}
                {t('rtmax_table_iso_entre_chevrons_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(nbRouleau || 0).toFixed(2)}
                {' '}
                {t('rtmax_table_iso_entre_chevrons_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTablertMax">
                <Form className="inputInTable">
                  <Form.Input
                    type="number"
                    onClick={e => e.target.select()}
                    step={0.10}
                    width={8}
                    disabled={token === null || UserService.isUser()}
                    value={
                      entreChevronsItem && entreChevronsItem.noFormat
                        ? entreChevronsItem && entreChevronsItem.price
                        : Number(entreChevronsItem && entreChevronsItem.price).toFixed(2)
                    }
                    onChange={(e, val) => this.changeEntreChevronsPriceRtmax(e, val, true)}
                    onBlur={
                      () => {
                        this.changeEntreChevronsPriceRtmax(
                          null,
                          { value: entreChevronsItem && entreChevronsItem.price },
                          false
                        );
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {' '}
                    {t('rtmax_table_iso_entre_chevrons_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {Number(tarifPerSurface || 0).toFixed(2)}
                {t('rtmax_table_iso_entre_chevrons_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            )
          }
              <Table.Row>
                <Table.Cell>
                  {1 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  {t('rtmax_table_iso_sous_chevrons')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtmaxPdf(
                        sousChevronsItem.link && sousChevronsItem.link.length > 0
                          ? sousChevronsItem.link
                          : kitFit035
                      )
                    }
                  />
                  <br />
                  <Dropdown
                    search
                    selection
                    disabled
                    options={sousChevronsOptions}
                    value={sousChevronsItem}
                    onChange={(e, val) => this.changeSousChevronsRtmax(e, val)
                }
                  />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {' '}
                  {(surfaceSousChevrons || 0).toFixed(2)}
                  {t('rtmax_table_iso_sous_chevrons_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(nbreRouleau || 0).toFixed(2)}
                  {' '}
                  {t('rtmax_table_iso_sous_chevrons_rouleau')}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      onClick={e => e.target.select()}
                      type="number"
                      disabled={token === null || UserService.isUser()}
                      value={
                      sousChevronsItem && sousChevronsItem.noFormat
                        ? sousChevronsItem && sousChevronsItem.price
                        : Number(sousChevronsItem && sousChevronsItem.price).toFixed(2)
                    }
                      onChange={(e, val) => this.changeSousChevronsPriceRtmax(e, val, true)}
                      onBlur={
                        () => {
                          this.changeSousChevronsPriceRtmax(
                            null,
                            { value: sousChevronsItem && sousChevronsItem.price },
                            false
                          );
                        }
                      }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtmax_table_iso_sous_chevrons_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifOnSurface || 0).toFixed(2)}
                  {t('rtmax_table_iso_sous_chevrons_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {2 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  {t('rtmax_table_suspentes')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtmaxPdf(
                        suspentesItem && suspentesItem.link.length > 0
                          ? suspentesItem.link
                          : suspentes
                      )
                    }
                  />
                  <br />
                  <Dropdown
                    search
                    selection
                    disabled
                    options={suspentesOptions}
                    value={suspentesItem}
                    onChange={(e, val) => this.changeSuspenteRtmax(e, val)}
                  />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(suspentesRtmax || 0).toFixed(2)}
                  {' '}
                  {t('rtmax_table_suspentes_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(suspentesQuantityRtmax || 0).toFixed(2)}
                  {t('rtmax_table_suspentes_boites')}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      onClick={e => e.target.select()}
                      step={0.10}
                      type="number"
                      disabled={token === null || UserService.isUser()}
                      value={
                      suspentesItem && suspentesItem.noFormat
                        ? suspentesItem && suspentesItem.price
                        : Number(
                          suspentesItem && suspentesItem.price
                            ? suspentesItem.price
                            : '0'
                        ).toFixed(2)
                    }
                      onChange={(e, val) => this.changeSuspentesPriceRtmax(e, val, true)}
                      onBlur={
                      () => {
                        this.changeSuspentesPriceRtmax(
                          null,
                          { value: suspentesItem && suspentesItem.price },
                          false
                        );
                      }
                    }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtmax_table_suspentes_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifDeSurface || 0).toFixed(2)}
                  {t('rtmax_table_suspentes_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {3 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  {t('rtmax_table_membrane')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtmaxPdf(
                        membranesItemRtmax && membranesItemRtmax.link.length > 0
                          ? membranesItemRtmax.link
                          : pareVapeur
                      )
                    }
                  />
                  <br />
                  <Dropdown
                    search
                    selection
                    defaultValue={membranesItemRtmax}
                    value={membranesItemRtmax}
                    options={membraneOptions}
                    onChange={(e, val) => this.changeMembraneRtmax(e, val)}
                  />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(membranePareVapeurRtmax || 0).toFixed(2)}
                  {t('rtmax_table_membrane_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(membraneRouleauxRtmax || 0).toFixed(2)}
                  {' '}
                  {t('rtmax_table_membrane_rouleau')}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  <Form className="inputInTable">
                    <Form.Input
                      onClick={e => e.target.select()}
                      type="number"
                      width={8}
                      step={0.10}
                      disabled={token === null || UserService.isUser()}
                      value={
                      membranesItemRtmax && membranesItemRtmax.noFormat
                        ? membranesItemRtmax && membranesItemRtmax.price
                        : Number(membranesItemRtmax && membranesItemRtmax.price).toFixed(2)
                    }
                      onChange={(e, val) => this.changeMembranePriceRtmax(e, val, true)}
                      onBlur={
                      () => {
                        this.changeMembranePriceRtmax(
                          null,
                          { value: membranesItemRtmax && membranesItemRtmax.price },
                          false
                        );
                      }
                    }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtmax_table_membrane_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifMembraneRtmax || 0).toFixed(2)}
                  {t('rtmax_table_membrane_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {4 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  {t('rtmax_table_adhesif')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtmaxPdf(
                        adhesifRtMaxPdfPath && adhesifRtMaxPdfPath.length > 0
                          ? adhesifRtMaxPdfPath
                          : adhesifRtMaxPdf
                      )
                    }
                  />
                  <br />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(adhesifCost || 0).toFixed(2)}
                  {t('rtmax_table_adhesif_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(adhesifBox || 0).toFixed(2)}
                  {t('rtmax_table_adhesif_rouleau')}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      onClick={e => e.target.select()}
                      disabled={token === null || UserService.isUser()}
                      value={
                      selectedAdhesif && selectedAdhesif.noFormat
                        ? selectedAdhesif && selectedAdhesif.price
                        : Number((selectedAdhesif && selectedAdhesif.price) || 0).toFixed(2)
                    }
                      onChange={(e, val) => this.changeAdhesifRtmaxPrice(e, val, true)}
                      onBlur={
                        () => this.changeAdhesifRtmaxPrice(
                          null, { value: selectedAdhesif && selectedAdhesif.price }, false)}
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtmax_table_adhesif_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(adhesifCost || 0).toFixed(2)}
                  {t('rtmax_table_adhesif_tarifsurface')}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {5 + (showMonocouche ? 0 : 1)}
                  .
                  {' '}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  {t('rtmax_table_mastic')}
                  <TechnicalInfoIcon
                    onClick={
                      () => this.clickDownloadRtmaxPdf(
                        masticRtMaxPdfPath.length > 0
                          ? masticRtMaxPdfPath
                          : masticRtMaxPdf
                      )
                    }
                  />
                  <br />
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {(masticRTSolution || 0).toFixed(2)}
                  {t('rtmax_table_mastic_surface')}
                </Table.Cell>
                <Table.Cell className="cellTableQuantity">
                  {(masticrtMaxQuantity || 0).toFixed(2)}
                  {t('rtmax_table_mastic_cartouches')}
                </Table.Cell>
                <Table.Cell className="cellTablertMax">
                  <Form className="inputInTable">
                    <Form.Input
                      width={8}
                      step={0.10}
                      type="number"
                      onClick={e => e.target.select()}
                      disabled={token === null || UserService.isUser()}
                      value={
                      masticNoFormat
                        ? masticPrice
                        : Number(masticPrice).toFixed(2)
                    }
                      onChange={(e, val) => this.changeMasticrtMaxPrice(e, val, true)}
                      onBlur={
                        () => {
                          this.changeMasticrtMaxPrice(
                            null,
                            { value: masticPrice },
                            false
                          );
                        }
                      }
                    />
                    <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                      {t('rtmax_table_mastic_price')}
                    </Label>
                  </Form>
                </Table.Cell>
                <Table.Cell className="cellTable">
                  {Number(tarifMasticRt || 0).toFixed(2)}
                  {t('rtmax_table_mastic_tarifsurface')}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        );
      case envList.IME.path:
        return (
          <ComponentTableIME
            resValue={resValue}
            isoValue={isoValue}
            onThermalChange={(thermalValue) => {
              this.setState({ thermalValueRtmax: thermalValue });
            }}
            onTotalChange={(total) => {
              this.setState({ rtMaxTotal: total });
            }}
            onIsEnoughChange={(enought) => {
              this.setState({ isEnough: enought });
            }}
            onConformitychange={(conformity) => {
              this.setState({ conformityRtmax: conformity });
            }}
            worktype="2"
          />
        );
      case envList.CP.path: {
        const {
          adhesives,
          costInsBet,
          costMem,
          costSec,
          insulators,
          insulatorsSecond,
          masticBox,
          masticCost,
          mastics,
          membranes,
          nbRollInsBet,
          nbRollMem,
          nbRollSec,
          selectedAdhesive,
          selectedInsulator,
          selectedInsulatorSecond,
          selectedMastic,
          selectedMembrane,
          usedAdhesif,
          usedInsBet,
          usedMastic,
          usedMem,
          usedSec,
        } = this.state;

        const componentsData = [
          {
            costInsBet,
            insulators,
            nbRollInsBet,
            onBlur: onBlurFactory(
              'insulator',
              this,
              selectedInsulator,
              ProductType.INSULATOR,
              isoValue,
              env,
            ),
            onChange: onChangeFactory('selectedInsulator', this, selectedInsulator),
            selectedInsulator,
            usedInsBet,
          },
          {
            costSec,
            insulatorsSecond,
            nbRollSec,
            selectedInsulatorSecond,
            usedSec,
            onChange: onChangeFactory('selectedInsulatorSecond', this, selectedInsulatorSecond),
            onBlur: onBlurFactory(
              'insulatorSecond',
              this,
              selectedInsulatorSecond,
              ProductType.INSULATOR_SECOND,
              isoValue,
              env,
            ),
          },
          {
            costMem,
            membranes,
            nbRollMem,
            selectedMembrane,
            usedMem,
            onChangeList: this.onChangeMembrane,
            onChange: onChangeFactory('selectedMembrane', this, selectedMembrane),
            onBlur: onBlurFactory(
              'membrane',
              this,
              selectedMembrane,
              ProductType.MEMBRANE,
              isoValue,
              env,
            ),
          },
          {
            adhesifBox,
            adhesifCost,
            adhesives,
            selectedAdhesive,
            usedAdhesif,
            onChange: onChangeFactory('selectedAdhesive', this, selectedAdhesif),
            onBlur: onBlurFactory(
              'adhesive',
              this,
              selectedAdhesif,
              ProductType.ADHESIVE,
              isoValue,
              env,
            ),
          },
          {
            masticBox,
            masticCost,
            mastics,
            selectedMastic,
            usedMastic,
            onChange: onChangeFactory('selectedMastic', this, selectedMastic),
            onBlur: onBlurFactory(
              'mastic',
              this,
              selectedMastic,
              ProductType.MASTIC,
              isoValue,
              env,
            ),
          },
        ];
        return (
          <ComponentTable
            t={t}
            worktype={2}
            match={match}
            components={componentsData}
          />
        );
      }
      default:
        return null;
    }
  }

  render() {
    const { t, match: { params: { env } }, history, location: { state } } = this.props;
    const {
      conformityRtmax,
      isEnough,
      modalRtMaxMonocoucheOpen,
      resValue,
      rtMaxTotal,
      showMonocouche,
      thermalValueRtmax,
      modalOpen,
    } = this.state;
    const { formula: { rtMax } } = productInfos[env];

    return (
      <div>
        <Modal
          id="ModalExportMail"
          open={modalOpen}
          onClose={this.handleCloseConfig}
        >
          <Header
            icon="times"
            color="red"
            content={t('title_modal_impossible_configuration')}
          />
          <Modal.Content>
            <h3>{t('incompatible_modal_epaisseur_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={{ pathname: getFirstPage(env), state }}>
              <Button color="red" onClick={this.handleCloseConfig} inverted>
                <Icon name="checkmark" />
                {' '}
                OK
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>

        <Modal
          id="ModalExportMail"
          open={modalRtMaxMonocoucheOpen}
          onClose={this.handleClose}
        >
          <Header icon="times" color="red" content="Aucune solution" />
          <Modal.Content>
            <h3>{t('incompatible_modal_rtmax_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link to={{ pathname: getFirstPage(env), state }}>
              <Button color="red" onClick={this.handleClose} inverted>
                <Icon name="reply" />
                {' '}
                {t('incompatible_modal_ok')}
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
        <HeaderComponent
          currentPage={4}
          commonState={this.state}
          history={history}
        />
        <Container id="rtMaxSoluce">
          <Segment>
            <Container as="h2" id="rtMaxTitle">
              {t('rtmax_solution_title')}
            </Container>

            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column width={100}>
                  { rtMax.displayTuto && (
                  <YoutubeModal videoId={rtMax.tutoVideoId} height="400px" width="700px">
                    <Button
                      floated="right"
                      id="tutorialButtonrtMax"
                      size="big"
                      target="_blank"
                    >
                      {t('rtmax_tutorial_button')}
                      <Icon name="wrench" id="iconTuto" />
                    </Button>
                  </YoutubeModal>
                  )}
                  <Segment basic id="rtMaxText">
                    {t(rtMax.descriptionKey[JobList.PRO])}
                    {' '}
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Segment basic>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      <ul className="avantageRtmaxTitle">
                        {t('rtmax_advantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      <ul className="avantageRtmaxTitle">
                        {t('rtmax_disadvantages_title')}
                      </ul>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid columns="equal" id="tabContainer">
                <Grid.Row>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      {this.advantagesrender()}
                    </div>
                  </Grid.Column>
                  <Grid.Column className="tabCell rtMaxCell">
                    <div className="rowText">
                      {this.inconvenienceRender()}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment>
              <Grid>
                <Grid.Row>
                  <Grid.Column
                    id="divImagertMax"
                    computer={8}
                    tablet={16}
                    style={{
                      display: 'flex',
                    }}
                  >
                    <Image
                      src={
                        !showMonocouche
                          ? rtMax.composantsImg
                          : rtMax.composantsBicImg
                      }
                      size="big"
                    />
                    {rtMax.asterisk ? '*' : ''}
                  </Grid.Column>
                  <Grid.Column
                    computer={8}
                    tablet={16}
                    id="col_comp"
                  >
                    <List divided relaxed fluid ordered>
                      <Label as="h2" id="composantTitlertMax">
                        {t('rtmax_component_list')}
                      </Label>
                      {this.componentRender()}
                    </List>
                    {rtMax.asterisk ? t('asterisk') : ''}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <Segment className="segmentPanneau">
              <Grid>
                <Grid.Row id="rtMaxPanneau">
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic>
                      <div as="h4" className="rtMaxSoluceTitle">
                        {t('rtmax_reswait')}
                      </div>
                      <div className="SoluceNumbers">
                        {resValue}
                        {t('rtmax_res_unit')}
                      </div>
                      <div className="underlinePanneau">
                        ______________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={8} computer={4}>
                    <Segment basic>
                      <div as="h4" className="rtMaxSoluceTitle">
                        {t('rtmax_thermal_res')}
                      </div>
                      <div
                        className={
                          isEnough
                            ? 'SoluceNumbers'
                            : 'SoluceNumbers Invalid'
                        }
                      >
                        {Number.isNaN(thermalValueRtmax) ? 0 : thermalValueRtmax}
                        {t('rtmax_thermal_res_unit')}
                      </div>
                      <div
                        className={
                          isEnough
                            ? 'underlinePanneau'
                            : 'underlinePanneau Invalid'
                        }
                      >
                        ______________________________
                      </div>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column tablet={12} computer={8}>
                    { productInfos[env].haveCpt
                      && (
                      <Segment basic>
                        <div as="h4" className="rtMaxSoluceTitle">
                          {t('rtmax_conformity')}
                        </div>
                        <div
                          className={
                          conformityRtmax
                            ? 'SoluceNumbers'
                            : 'SoluceNumbers Invalid'
                        }
                        >
                          {conformityRtmax
                            ? t('rtmax_conformity_res')
                            : t('rtmax_conformity_resp')}
                        </div>
                        <div
                          className={
                          conformityRtmax
                            ? 'underlinePanneau'
                            : 'underlinePanneau Invalid'
                        }
                        >
                          ______________________________
                        </div>
                      </Segment>
                      )
                  }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            {this.renderComponentTable()}

            <Segment basic id="totalRtMax">
              <List floated="right" horizontal>
                <List.Item id="textTotalRtMax">{t('rtmax_total')}</List.Item>
                <List.Item id="totalNumbersRtMax">
                  {Math.ceil(
                    Number(rtMaxTotal) || 0
                  ).toLocaleString()}
                  {' '}
                  €
                </List.Item>
                <List.Item id="underscoreTotalRtMax">
                  ____________________________
                </List.Item>
              </List>
            </Segment>
            <Segment basic id="nextButtonRtMax">
              <Button
                floated="right"
                color="green"
                size="big"
                id="btnNext"
                onClick={() => this.screenPage()}
              >
                {t('rtmax_next_button')}
                <Icon name="long arrow alternate right" />
              </Button>
            </Segment>
          </Segment>
        </Container>
      </div>
    );
  }
}

rtMaxSoluceComponent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      env: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({

    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  t: ProductType.func,
};

export default translate('rtMaxSoluceComponent')(rtMaxSoluceComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/rtmax/RtMaxSoluceComponent.jsx